import { useEffect, useState, type ReactNode } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { roleName } from "./format";
import { AlertToast, useIncidentAlerts } from "./IncidentAlerts";

/** Меню сгруппировано по задачам: что происходит, что было, наука, управление. */
export function Layout({ children }: { children: ReactNode }) {
  const { me, logout } = useAuth();
  // Уведомления о срочных — тем, кто обрабатывает инциденты, а не инспектору.
  const alerts = useIncidentAlerts(!!me && me.can_read_patrol_data && me.role !== "inspector");
  // На телефоне меню свёрнуто под кнопку и закрывается после перехода.
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setMenuOpen(false), [pathname]);
  if (!me) return null;

  return (
    <div className="layout">
      <aside className={menuOpen ? "sidebar open" : "sidebar"}>
        <div className="sidebar-head">
          <div className="brand">
            <div className="brand-mark" aria-hidden="true" />
            <div className="brand-name">Патрулирование<br /><span>ООПТ ДНР</span></div>
          </div>
          <button className="secondary menu-toggle" aria-expanded={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? "Закрыть" : "Меню"}
            {!menuOpen && alerts.newCount > 0 && <span className="nav-badge" aria-label={`новых: ${alerts.newCount}`}>{alerts.newCount}</span>}
          </button>
        </div>

        <div className="sidebar-body">

          {me.can_read_patrol_data && (
            <nav className="nav-group" aria-label="Оперативное">
              <div className="nav-group-title">Оперативное</div>
              <NavLink to="/incidents">
                Инциденты{alerts.newCount > 0 && <span className="nav-badge" aria-label={`новых: ${alerts.newCount}`}>{alerts.newCount}</span>}
              </NavLink>
              <NavLink to="/map">Карта</NavLink>
            </nav>
          )}
          {me.can_read_patrol_data && (
            <nav className="nav-group" aria-label="Журналы">
              <div className="nav-group-title">Журналы</div>
              {me.can_manage_users && <NavLink to="/assignments">Назначения</NavLink>}
              <NavLink to="/shifts">Смены и обходы</NavLink>
              <NavLink to="/reports">Отчёты</NavLink>
            </nav>
          )}
          <nav className="nav-group" aria-label="Наука">
            <div className="nav-group-title">Наука</div>
            <NavLink to="/observations">Наблюдения</NavLink>
            {!me.can_read_patrol_data && <NavLink to="/reports">Отчёты</NavLink>}
            {me.can_manage_species && !me.can_manage_reference && <NavLink to="/reference">Справочник видов</NavLink>}
          </nav>
          {me.can_manage_users && (
            <nav className="nav-group" aria-label="Управление">
              <div className="nav-group-title">Управление</div>
              <NavLink to="/users">Сотрудники</NavLink>
              <NavLink to="/geo">Территории и маршруты</NavLink>
              <NavLink to="/tags">Контрольные точки</NavLink>
              <NavLink to="/tokens">Личные жетоны</NavLink>
              <NavLink to="/equipment">Имущество</NavLink>
              <NavLink to="/devices">Устройства</NavLink>
              {me.can_manage_reference && <NavLink to="/reference">Справочники</NavLink>}
              {me.can_read_audit && <NavLink to="/audit">Журнал аудита</NavLink>}
              {me.can_read_audit && <NavLink to="/status">Диагностика</NavLink>}
            </nav>
          )}

          <div className="who">
            <strong>{me.full_name}</strong>
            <div style={{ marginBottom: 10 }}>{roleName[me.role] ?? me.role}</div>
            <button className="secondary" onClick={() => void logout()}>Выйти</button>
          </div>
        </div>
      </aside>

      <main className="main">{children}</main>
      <AlertToast fresh={alerts.fresh} dismiss={alerts.dismiss} />
    </div>
  );
}
